import { render, staticRenderFns } from "./EmpresaManage.vue?vue&type=template&id=08fd6743"
import script from "./EmpresaManage.vue?vue&type=script&lang=js"
export * from "./EmpresaManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports